'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = require('@progress/kendo-base-components-vue-wrapper');

exports.default = {
    name: 'kendo-menu-item',
    render: function render(h) {
        return h('span', this.$slots.default);
    },

    mixins: [_kendoBaseComponentsVueWrapper.KendoSharedMethods],
    props: {
        text: String,
        cssClass: String,
        url: String,
        attr: Object,
        encoded: Boolean,
        content: String,
        contentAttr: Object,
        imageAttr: Object,
        imageUrl: String,
        items: Array,
        spriteCssClass: String,
        select: Function
    },
    mounted: function mounted() {
        this._resolveInnerChildren();
    },

    methods: {
        _resolveInnerChildren: function _resolveInnerChildren() {
            if (!this.$options.propsData['items'] && this.$slots.default) {
                var items = this.resolveInnerTags('kendo-menu-item');
                this.subitems = items;
            }
        }
    }
};